<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editEmployeeData') }}</h1>
      <div class="form-container">
        <EmployeeDataForm @save="save"
                          :employee-data="employeeData">
        </EmployeeDataForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState} from 'vuex'
  import DashboardLayout from '@/components/DashboardLayout'
  import EmployeeDataForm from '@/components/EmployeeDataForm'

  export default {
    components: {
      DashboardLayout,
      EmployeeDataForm
    },
    methods: {
      save(form) {
        this.$store.dispatch('Employees/update', form).then(() => {
          this.$locale.change(form.locale)
          this.$store.commit('Account/SET_PREVIEW', form.document_preview)
          this.$router.push({
            name: 'employeeDetail',
            params: {employeeId: this.$route.params.employeeId}
          })
        })
      }
    },
    mounted() {
      this.$store.dispatch('Employees/readAccountData')
    },
    computed: {
      ...mapState('Employees', ['employeeDetail']),
      ...mapState('Account', ['account']),
      employeeData() {
        return {
          ...this.employeeDetail,
          birthday: this.employeeDetail.birthday ? new Date(this.employeeDetail.birthday) : null,
          photo: null
        }
      },
      breadcrumbs() {
        return [
          {
            name: 'employeeDetail',
            path: {
              name: 'employeeDetail',
              params: {employeeId: this.$route.params.employeeId}
            }
          },
          {name: 'editEmployeeData'}
        ]
      }
    }
  }
</script>